import React from 'react';
import { Drawer } from '@mui/material';
import { DataProduct } from 'new/components/marketplace/components/DataProductsDrawer/components/DataProduct';

type DataProductsDrawerProps = {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
  datasetId: number;
};

export const DataProductsDrawer = (props: DataProductsDrawerProps) => {
  const { onClose, datasetId } = props;

  return (
    <Drawer keepMounted={false} open={!!datasetId} anchor="right" onClose={onClose}>
      <DataProduct {...props} />
    </Drawer>
  );
};
